<template>
  <section
    v-if="sections.length > 0"
    class="extra-sections"
    :class="wrapperClass"
  >
    <div class="container-fluid">
      <ExtraSectionBlock
        v-for="(section, index) in sections"
        :key="section.id"
        :section="section"
        :is-first-section="isFirstGroup && index === 0"
        :products="sectionProducts?.[section.id]"
        @image-click="onImageClick"
      />
    </div>
  </section>
</template>

<script setup lang="ts">
import type { ExtraSection } from '@/types/extraSection'
import ExtraSectionBlock from '@/components/home/ExtraSectionBlock.vue'

defineProps<{
  sections: ExtraSection[]
  wrapperClass?: string
  isFirstGroup?: boolean
  sectionProducts?: Record<number, Array<{
    id: number
    name?: string
    title?: string
    description?: string
    price?: number
    image_url?: string
  }>>
}>()

const emit = defineEmits<{
  'image-click': [url: string]
}>()

const onImageClick = (url: string) => emit('image-click', url)
</script>
